<script setup>
// import { ref, onMounted, nextTick, computed } from 'vue'

const props = defineProps({
  total: {
    type: Number,
    default: 0,
  },
  completed: {
    type: Number,
    default: 0,
  },
  percentage: {
    type: Number,
    default: 0,
  },
  small: {
    type: Boolean,
    defualt: false,
  },
})

// document.jsVariables.
</script>

<template>
  <span
    class="ProgressIndicator"
    role="status"
    :class="{
      'ProgressIndicator--completed': percentage == 100,
      'ProgressIndicator--small': props.small,
    }"
  >
    <span class="visually-hidden">({{ props.percentage }}% abgeschlossen)</span>
    <div
      v-if="percentage < 100"
      class="ProgressIndicator-circle"
      :style="{ '--progress': percentage }"
    ></div>

    <svg v-if="percentage == 100" class="ProgressIndicator-icon">
      <use href="#check"></use>
    </svg>
  </span>
</template>
